import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from "../service/user.service";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class UserIsNotActiveGuard  {
    constructor(
        private router: Router,
        private userService: UserService
    ) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const isActive$ = state.url.includes('user/account')
            ? this.userService.userIsActiveEdit$()
            : this.userService.userIsActive$()
        return isActive$.pipe(
            map(isActive => {
                if (!isActive) {
                  return   this.router.parseUrl('/auth/signup')
                }
                return isActive
            })
        )
    }

}
